import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import * as UseUserGroups from "./useUserGroups";

export function useDeleteUserGroup() {
  const { userGroupService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (userGroupId) => userGroupService.remove(userGroupId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseUserGroups.getQueryKey(),
      });
    },
  });
}
